"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processNodes = void 0;
const convertNodeToReactElement_1 = require("./convertNodeToReactElement");
function processNodes(nodes, transform) {
    return nodes.map((node, index) => {
        if (transform) {
            const transformed = transform(node, index);
            if (transformed === null || !!transformed) {
                return transformed;
            }
        }
        return (0, convertNodeToReactElement_1.convertNodeToReactElement)(node, index, transform);
    });
}
exports.processNodes = processNodes;
